import { Toast as BaseToast } from '@base-ui/react/toast'
import type { PartProps } from '../../../lib/part-props'

interface ToastCloseProps extends PartProps<BaseToast.Close.Props> {}

function ToastClose(props: ToastCloseProps) {
  return <BaseToast.Close {...props} />
}

export { ToastClose }
